import {FontAwesomeIcon, PageHeader, Button} from "~/components";
import AiHistoryList from "../components/AiHistoryList";

/**
 * Lịch sử các lần gọi AI của user (root xem tất cả). Bảng + xem chi tiết + xoá được tách
 * ra component dùng chung `AiHistoryList` (cũng dùng cho tab lịch sử trong màn AI của dự án).
 */
function AiHistory() {
	return (
		<div className="container">
			<PageHeader
				icon="fa-light fa-clock-rotate-left"
				title="Lịch sử AI"
				subtitle="Các nội dung đã tạo bằng AI"
				actions={
					<Button to="/ai" white leftIcon={<FontAwesomeIcon icon="fa-light fa-wand-magic-sparkles" />}>
						Tạo nội dung mới
					</Button>
				}
			/>

			<AiHistoryList />
		</div>
	);
}

export default AiHistory;
